import {I18n} from 'react-redux-i18n';

const meetingRoomsSearchFields = (searchFieldValues, parentList) => {
    return {
        rows: [{
            hasTopBreak: false,
            hasBottomBreak: false,
            fields: [{
                id: "name",
                label: I18n.t('meetingRooms.list.name'),
                type: "text",
                value: searchFieldValues.name.value,
            }, {
                id: "parentId",
                label: I18n.t('meetingRooms.list.parent'),
                type: "dropdown",
                value: searchFieldValues.parentId.value,
                data: parentList
            }, {
                id: "email",
                label: I18n.t('meetingRooms.list.email'),
                type: "text",
                value: searchFieldValues.email.value,
            }]
        }, {
            hasTopBreak: false,
            hasBottomBreak: false,
            fields: [{
                id: "capacity",
                label: I18n.t('meetingRooms.list.capacity'),
                type: "dropdown",
                isMulti: false,
                value: searchFieldValues.capacity.value,
                data: capacitySearchFieldData
            }, {
                id: "status",
                label: I18n.t('meetingRooms.list.status'),
                type: "dropdown",
                value: searchFieldValues.status.value,
                data: getStatusSearchFieldData()
            }]
        }]
    }
};

const capacitySearchFieldData = [
    {value: "{\"maxCapacity\": 4 }", label: '< 5'},
    {value: "{\"minCapacity\": 5,  \"maxCapacity\": 10 }", label: '5 - 10'},
    {value: "{\"minCapacity\": 10, \"maxCapacity\": 20 }", label: '10 - 20'},
    {value: "{\"minCapacity\": 21 }", label: '> 20'},
];

const getStatusSearchFieldData = () => ([
    {value: "ENABLED", label: I18n.t('meetingRooms.status.enabled'),},
    {value: "DISABLED", label: I18n.t('meetingRooms.status.disabled'),},
    {value: "DISCONNECTED", label: I18n.t('meetingRooms.status.disconnected'),},
]);

const scheduleEventsSearchFields = searchFieldValues => {
    return {
        rows: [{
            hasTopBreak: false,
            hasBottomBreak: false,
            fields: [{
                id: "origin",
                label: I18n.t("meetingRooms.scheduleEvents.eventOrigin"),
                type: "dropdown",
                value: searchFieldValues.origin.value,
                data: Object.keys(eventOrigins).map(originKey => ({ 
                    value: originKey, 
                    label: I18n.t("meetingRooms.scheduleEvents.origins." + originKey)
                }))
            }, {
                id: "type",
                label: I18n.t("meetingRooms.scheduleEvents.eventType"),
                type: "dropdown",
                value: searchFieldValues.type.value,
                data: Object.keys(eventTypes).map(typeKey => ({ 
                    value: typeKey, 
                    label: I18n.t("meetingRooms.scheduleEvents.types." + typeKey)
                }))
            }]
        }]
    }
};

const eventOrigins = {
    BACKOFFICE: 'BACKOFFICE',
    SYSTEM: 'SYSTEM',
    CONSOLE: 'CONSOLE',
    PROVIDER: 'PROVIDER'
};

const eventTypes = {
    CREATE: 'CREATE',
    QUICK_BOOK: 'QUICK_BOOK',
    EXTEND: 'EXTEND',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    SYNCHRONIZATION: 'SYNCHRONIZATION',
    CHECK_IN: 'CHECK_IN',
    CHECK_OUT: 'CHECK_OUT'
};

export {
    meetingRoomsSearchFields,
    scheduleEventsSearchFields
}